import { Col, Grid, Skeleton } from 'gu-ui-kit'
import styles from 'modules/Services/Account/network-account.module.scss'
import clsx from 'clsx'
import React from 'react'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

export const Placeholder = () => {
  const breakpoints = useBreakpoint()

  return (
    <Skeleton shown>
      <Grid
        direction={breakpoints.fbs ? 'column' : 'row'}
        gap={breakpoints.fbs ? 0 : 16}
        className={styles['network-account__header']}
        wrap={false}
      >
        <Col className={styles['network-account__header-col']}>
          <Grid direction={'column'} gap={26}>
            <Grid direction={'column'} gap={6}>
              <Grid
                alignItems={'center'}
                direction={'row'}
                justifyContent={'between'}
                className={styles['network-account__logo-wrapper']}
              >
                <Col>
                  <Skeleton.Item
                    bgColor={'secondary-6'}
                    size={'s'}
                    width={150}
                  />
                </Col>
                <Col>
                  <Skeleton.Item
                    bgColor={'secondary-6'}
                    size={'s'}
                    width={50}
                  />
                </Col>
              </Grid>

              <Grid
                direction={'column'}
                gap={8}
                className={styles['network-account__account-description']}
              >
                <Skeleton.Item bgColor={'secondary-6'} size={'m'} width={250} />
                <Skeleton.Item bgColor={'secondary-6'} size={'s'} width={200} />
              </Grid>
            </Grid>
            <Grid
              className={styles['network-account__login-container']}
              alignItems={'center'}
            >
              <Skeleton.Item bgColor={'secondary-6'} size={'s'} width={350} />
            </Grid>
          </Grid>
        </Col>
        <Col
          className={clsx(
            styles['network-account__header-col'],
            styles['network-account__header-col_description'],
          )}
        >
          <Grid direction={'column'} gap={breakpoints.lg ? 27 : 25}>
            <Skeleton.Item bgColor={'secondary-6'} size={'s'} width={100} />
            <Skeleton.Item bgColor={'secondary-6'} size={'l'} width={200} />
            <Skeleton.Item bgColor={'secondary-6'} size={'m'} width={350} />
          </Grid>
        </Col>
      </Grid>
    </Skeleton>
  )
}
